export type DaycareCapacityDraft = {
  totalCapacity: number;
  limitBySize: boolean;
  capacitySmall: number;
  capacityMedium: number;
  capacityLarge: number;
};

export const getDisplayedCapacity = (draft: DaycareCapacityDraft): number =>
  draft.limitBySize
    ? draft.capacitySmall + draft.capacityMedium + draft.capacityLarge
    : draft.totalCapacity;
